import { observer } from 'mobx-react-lite'
import React from 'react'

import { useCategoryStore, useGlobalCopyStore, useSettingsStore } from '../../../../common'

import { CategorySelectorDrawer } from '../../../../categories'
import RulesListItem from '../components/RuleListItem'

const EditCategoryAction = observer(() => {
  const { settings: settingsCopy } = useGlobalCopyStore()
  const { categories } = useCategoryStore()
  const { selectedRule: rule, updateRuleCategory } = useSettingsStore()

  const [isOpen, setIsOpen] = React.useState(false)

  const handleClose = (): void => {
    setIsOpen(false)
  }

  const handleOpen = (): void => {
    setIsOpen(true)
  }

  const getCategoryName = (categoryGuid: string) => {
    return categories.find((category) => category.guid === categoryGuid)?.name
  }

  const handleCategorySelect = async (guid: string) => {
    if (rule && rule.category_guid !== guid) {
      rule.category_guid = guid
      await updateRuleCategory(rule)
    }
    handleClose()
  }

  return (
    <React.Fragment>
      <RulesListItem
        onClick={handleOpen}
        primaryText={rule?.category_guid ? getCategoryName(rule.category_guid) : ''}
        secondaryText={settingsCopy.category}
      />
      <CategorySelectorDrawer
        initialSelected={rule?.category_guid ? rule.category_guid : undefined}
        onClose={handleClose}
        onSelect={handleCategorySelect}
        showDrawer={isOpen}
        title={settingsCopy.select_category}
      />
    </React.Fragment>
  )
})

export default EditCategoryAction
